export default {"src":"/_next/static/media/TFC.17a88bff.svg","height":18,"width":18};